<template>
    <div>
        <top-nav v-if="stageType==1" :active="'/asmt/index'"></top-nav>
        <mobileTopNav v-if="stageType==2" title="心理测评"></mobileTopNav>

        <div class="mw mwCenter">

            <div class="formName">{{scale.scaleName}}</div>
            <div class="guideTip">{{ scale.guide }}</div>
            <div class="progress">
                <div class="usedTime">{{ usedTime }}</div>
                <el-progress :stroke-width="12" :percentage="calculatePercentage" :format="formatProgressText" :show-text="true"></el-progress>
            </div>
            <div class="overTip" v-if="currIdx>0 && currIdx==qstList.length">答题完成！</div>
            <div>
                <template v-for="(o,i) in qstList">
                    <div v-if="i==currIdx" :id="o.tkey" :key="'f'+i" class="fItem">
                        <div :class="'fdTitle '" v-if="o.stemShown"><span class="qstNo">{{o.qstNo}}</span>{{o.stem}}</div>
                        <div class="fdDescription" v-if="o.stemShown">{{o.description}}</div>

                        <!-- <div v-if="o.type==8" :class="'fdDivider '+ o.dividerStyle"></div> -->

                        <div v-if="o.type==101" class="optionsBox">
                            <el-radio-group v-model="eForm[o.key]" class="fdGroup" size="medium" @change="submit">
                                <template v-for="(nn,ii) in o.options">
                                    <el-radio class="block-radio" :label="ii" :key="'fr'+ii">{{nn.label}}</el-radio>
                                </template>
                            </el-radio-group>
                        </div>

                        <div v-if="o.type==102" class="optionsBox">
                            <el-checkbox-group v-model="eForm[o.key]" class="fdGroup" size="medium">
                                <template v-for="(nn,ii) in o.options">
                                    <el-checkbox class="block-radio" :label="ii" :key="'fc'+ii">{{nn.label}}</el-checkbox>
                                </template>
                            </el-checkbox-group>
                        </div>
                    </div>
                </template>
                <!-- <div class="clear20"></div>
                <div class="botBtn">
                    <el-button type="primary" size="medium" @click="submit">提交</el-button>
                </div> -->
            </div>

            <div class="clear20"></div>
        </div>

        <bot-nav v-if="stageType==1"></bot-nav>
    </div>
</template>

<script>
export default {
    name: "asmt_scale_flow",
    components: {},
    data () {
        return {
            stageType: '',
            recordId: '',
            scaleId: '',
            allScales: '',
            qstList: [],
            eForm: {},
            scale: {},
            currIdx: 0,
            beginTs: 0,
            overTs: 0,
            usedTime: '',
            cd: null,
        };
    },
    computed: {
        calculatePercentage () {
            if (this.qstList.length) {
                let completed = Object.keys(this.eForm).length;
                return Math.round((completed / this.qstList.length) * 100);
            } else {
                return 0;
            }
        }
    },
    watch: {
        '$route.query.scaleId': function (newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                if (this.cd) {
                    clearInterval(this.cd);
                    this.cd = null;
                }
                this.scaleId = newVal;
                this.recordId = this.$route.query.recordId;
                this.allScales = this.$route.query.allScales;
                this.qstList = [];
                this.eForm = {};
                this.currIdx = 0;
                this.beginTs = 0;
                this.overTs = 0;
                this.usedTime = '';
                this.loadScale();
                this.loadQsts();
                this.loadAnswer();
                this.startTimer();
            }
        }
    },
    methods: {
        formatProgressText () {
            if (this.qstList.length) {
                let completed = Object.keys(this.eForm).length;
                return completed + '/' + this.qstList.length;
            } else {
                return '0/0';
            }
        },
        centerConfirmCallback: function (param) {
            if (param && param.code) {
                if (param.code == 'cust_ok') {
                    this.centerDialogVisible = false;
                }
            }
        },
        fieldDecode: function (list) {
            let _this = this;
            list.forEach(function (n, i) {
                n.stemShown = n.stemShown ? true : false;
                n.required = n.required ? true : false;
                if (n.type == 5 || n.type == 6 || n.type == 7 || n.type == 101 || n.type == 102) {
                    n.options = JSON.parse(n.options);
                }
                if (n.type == 6 || n.type == 102) {
                    _this.$set(_this.eForm, n.key, []);
                }

                if (n.defaultVal) {
                    if (n.type == 6 || n.type == 102) {
                        n.defaultVal = JSON.parse(n.defaultVal);
                    }
                    _this.$set(_this.eForm, n.key, n.defaultVal);
                }
            });
            return list;
        },
        loadQsts: function () {
            let _this = this;
            let param = { formId: this.scaleId, formType: 2, };
            this.req('/pap_qst_list_from_cache', param, function (data) {
                if (data.success) {
                    _this.qstList = _this.fieldDecode(data.obj);
                }
            });
        },
        loadScale: function () {
            let _this = this;
            this.req('/pap_scale?id=' + this.scaleId + '&fromCache=true', {}, function (data) {
                if (data.success) {
                    _this.scale = data.obj;
                }
            }, 'get');
        },
        loadAnswer: function () {
            let _this = this;
            let param = {
                recordId: this.recordId,
                scaleId: this.scaleId,
            };

            this.req('/pap_asmt_scale_by_unk', param, function (data) {
                if (data.success) {
                    if (data.obj) {
                        _this.eForm = JSON.parse(data.obj.answerVals);
                        _this.calcCurrIdx();
                        _this.buildBegin(data.obj.createTime);
                        _this.buildOver(data.obj.overTime);
                    } else {
                        _this.showBeginTip();
                    }
                }
            });
        },
        async showBeginTip () {
            const res = await this.$confirm('开始答题？', '提示', {
                showClose: true,
                closeOnClickModal: false,
                confirmButtonText: '确定',
                showCancelButton: false,
                // cancelButtonText: '取消',
                type: 'info '
            }).catch(() => {
                return false;
            });

            if (res) {
                this.submit();
            } else {
                this.$router.back();
            }
        },
        calcCurrIdx: function () {
            this.currIdx = Object.keys(this.eForm).length;
        },
        buildBegin: function (tm) {
            if (tm) {
                this.beginTs = new Date(tm).getTime();
            } else {
                this.beginTs = 0;
            }
        },
        buildOver: function (tm) {
            if (tm) {
                this.overTs = new Date(tm).getTime();
            } else {
                this.overTs = 0;
            }
        },
        startTimer: function () {
            let _this = this;
            this.cd = setInterval(function () {
                if (_this.beginTs) {
                    let end = _this.overTs;
                    if (!end) {
                        end = new Date().getTime();
                    }
                    let usedTs = end - _this.beginTs;
                    if (usedTs < 0) {
                        usedTs = 0;
                    }
                    if (usedTs === 0) {
                        _this.usedTime = '--';
                    } else {
                        _this.usedTime = _this.lib.formatMilliseconds(usedTs);
                    }
                }
            }, 1000);
        },

        submit: function () {
            let _this = this;
            let eFormStr = JSON.stringify(this.eForm);
            let param = {
                answerVals: eFormStr,
                recordId: this.recordId,
                scaleId: this.scaleId,
            };

            this.req('/pap_asmt_scale_sub_answer', param, function (data) {
                if (data.success) {
                    if (data.obj) {
                        if (data.obj.createTime) {
                            _this.buildBegin(data.obj.createTime);
                        }
                        if (data.obj.overTime) {
                            _this.buildOver(data.obj.overTime);

                            _this.$message.success('答题完成！');
                            _this.calcCurrIdx();
                            _this.checkNextScale();
                        }
                    }
                    setTimeout(function () {
                        _this.calcCurrIdx();
                    }, 500);
                } else {
                    _this.$message.error(data.message);
                }
            }, 'post', false);
        },
        checkNextScale: function () {
            let _this = this;

            let allScaleList = [];
            if (this.allScales) {
                this.allScales.split(',').forEach(function (s) {
                    let parts = s.split('_');
                    allScaleList.push({ id: parts[0], type: parseInt(parts[1]) });
                });
            }

            this.req('/pap_asmt_scale_list', { recordId: this.recordId, qrySimple: true }, async function (data) {
                if (data.success) {
                    let doneMap = {};
                    data.obj.forEach(function (n) {
                        if (n.status == 1) {
                            doneMap[n.scaleId] = true;
                        }
                    });

                    let unDoneList = [];
                    allScaleList.forEach(function (s) {
                        if (!doneMap[s.id]) {
                            unDoneList.push(s);
                        }
                    });
                    let unDoneCount = unDoneList.length;
                    let doneCount = allScaleList.length - unDoneCount;

                    if (unDoneCount > 0) {
                        const res = await _this.$confirm('您已完成' + doneCount + '个量表，还有' + unDoneCount + '个量表未完成，是否继续测试？', '提示', {
                            closeOnClickModal: false,
                            confirmButtonText: '继续',
                            showCancelButton: false,
                            // cancelButtonText: '返回',
                            type: 'info'
                        }).catch(() => { return false; });

                        if (res) {
                            let nextScale = unDoneList[0];
                            if (nextScale.type == 1) {
                                _this.$router.replace({ path: '/asmt/asmt_scale_paper_survey', query: { scaleId: nextScale.id, recordId: _this.recordId, allScales: _this.allScales } });
                            } else {
                                _this.$router.replace({ path: '/asmt/asmt_scale_flow', query: { scaleId: nextScale.id, recordId: _this.recordId, allScales: _this.allScales } });
                            }
                        } else {
                            _this.$router.back();
                        }
                    } else {
                        const res = await _this.$confirm('全部量表已完成，是否退出登录？', '提示', {
                            closeOnClickModal: false,
                            confirmButtonText: '退出登录',
                            showCancelButton: false,
                            // cancelButtonText: '返回',
                            type: 'warning'
                        }).catch(() => { return false; });

                        if (res) {
                            sessionStorage.removeItem("hwt-token");
                            sessionStorage.removeItem("uid");
                            sessionStorage.removeItem("realName");
                            sessionStorage.removeItem("type");
                            sessionStorage.removeItem("showCust");
                            _this.$router.push("/login");
                        } else {
                            _this.$router.back();
                        }
                    }
                } else {
                    _this.$router.back();
                }
            });
        },
    },
    mounted: function () {
        this.$nextTick(function () {
            this.stageType = sessionStorage.getItem("stageType");
            this.recordId = this.$route.query.recordId;
            this.scaleId = this.$route.query.scaleId;
            this.allScales = this.$route.query.allScales;

            this.loadScale();
            this.loadQsts();
            this.loadAnswer();

            this.startTimer();
        });
    },
    beforeDestroy: function () {
        if (this.cd) {
            clearInterval(this.cd);
        }
    },
};
</script>
<style scoped>
.mwCenter {
    max-width: 800px;
    padding: 20px 20px;
    box-sizing: border-box;
    min-height: 600px;
}
.formName {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    padding-bottom: 10px;
    width: 80%;
    margin: auto;
}
.guideTip {
    font-size: 14px;
    font-weight: normal;
    color: #666;
}
.fItem {
    min-height: 40px;
    margin: 0px auto;
    box-sizing: border-box;
    padding: 15px 0px;
    position: relative;
    box-sizing: border-box;
}

.fdTitle {
    padding-bottom: 5px;
    min-height: 20px;
    line-height: 20px;
    color: #1f2d3d;
    font-weight: 600;
    word-wrap: break-word;
    word-break: break-all;
    position: relative;
    font-size: 16px;
    font-weight: bold;
    border-width: 0;
}
.qstNo {
    padding-right: 5px;
}
.fdDescription {
    font-size: 12px;
    color: #999;
    padding-bottom: 5px;
}

.botBtn {
    text-align: center;
}

.fdGroup .el-radio {
    margin-bottom: 20px;
    margin-top: 10px;
    font-size: 16px;
}

.block-radio {
    display: block; /* 关键：使每个选项成为块级元素 */
}

.optionsBox {
    background-color: #077cf511;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #077cf533;
    margin-top: 20px;
}

.progress {
    padding: 30px 0;
    position: relative;
}
.usedTime {
    width: auto;
    position: absolute;
    z-index: 10;
    right: 10px;
    top: 0px;
    font-size: 14px;
    color: #666;
}
.overTip {
    text-align: center;
    background-color: #077cf511;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #077cf533;
    margin-top: 20px;
}

@media (max-width: 770px) {
}
</style>


// WEBPACK FOOTER //
// src/components/asmt/asmt_scale_flow.vue